import gql from 'graphql-tag';

export const GetLoyaltyGooglePayPass = gql`
  query GetLoyaltyGooglePayPass($cardId: String!) {
    getLoyaltyCardGooglePass(cardId: $cardId) {
      jwt
    }
  }
`;

export const GetLoyaltyCategoryQuery = gql`
  query LoyaltyCategory {
    allLoyaltyConfigurations {
      categories {
        _id
        name {
          locale: _LANG_
        }
        description {
          localeRaw: _LANG_Raw
        }
        options {
          name {
            locale: _LANG_
          }
          description {
            localeRaw: _LANG_Raw
          }
          points
          _id
        }
      }
    }
  }
`;

export const GetLoyaltyTierQuery = gql`
  query LoyaltyTier {
    allLoyaltyConfigurations {
      bankMyRewardTier {
        name {
          _LANG_
        }
        description {
          localeRaw: _LANG_Raw
        }
        points
        _id
      }
    }
  }
`;

export const GetLoyaltyOnboardingQuickSelectTierQuery = gql`
  query LoyaltyOnboardingQuickSelectTier {
    allLoyaltyConfigurations {
      onboardingQuickSelectTiers {
        name {
          locale: _LANG_
        }
        description {
          localeRaw: _LANG_Raw
        }
        points
        _id
      }
    }
  }
`;
